import { useTranslation } from "react-i18next";
import { Shield, ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";

export default function PrivacyPolicyPage() {
  const { t } = useTranslation();
  const { lang } = useParams();
  const l = lang || 'lv';

  return (
    <div className="min-h-screen bg-background">
      <header className="bg-white border-b border-border sticky top-0 z-50">
        <div className="section-container py-4">
          <div className="flex items-center justify-between">
            <Link to={`/${l}`} className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary rounded-xl flex items-center justify-center">
                <Shield className="w-6 h-6 text-primary-foreground" />
              </div>
              <div>
                <span className="text-xl font-bold text-foreground block" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("nav.brand")}</span>
                <span className="text-xs text-muted-foreground">{t("nav.brandSub")}</span>
              </div>
            </Link>
            <Link to={`/${l}`} className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors">
              <ArrowLeft className="w-5 h-5" />
              <span>{t("privacy.back")}</span>
            </Link>
          </div>
        </div>
      </header>

      <main className="section-container py-12 md:py-20">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-10" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("privacy.title")}</h1>

          <div className="prose prose-lg max-w-none text-foreground/80">
            <section className="mb-10">
              <h2 className="text-xl font-bold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("privacy.s1Title")}</h2>
              <p className="mb-4 leading-relaxed">{t("privacy.s1p1")}</p>
              <p className="leading-relaxed">{t("privacy.s1p2")}</p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("privacy.s2Title")}</h2>
              <p className="mb-4 leading-relaxed">{t("privacy.s2p1")}</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>{t("privacy.s2l1")}</li>
                <li>{t("privacy.s2l2")}</li>
                <li>{t("privacy.s2l3")}</li>
                <li>{t("privacy.s2l4")}</li>
                <li>{t("privacy.s2l5")}</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("privacy.s3Title")}</h2>
              <p className="mb-4 leading-relaxed">{t("privacy.s3p1")}</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>{t("privacy.s3l1")}</li>
                <li>{t("privacy.s3l2")}</li>
                <li>{t("privacy.s3l3")}</li>
                <li>{t("privacy.s3l4")}</li>
                <li>{t("privacy.s3l5")}</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("privacy.s4Title")}</h2>
              <p className="leading-relaxed">{t("privacy.s4p1")}</p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("privacy.s5Title")}</h2>
              <p className="mb-4 leading-relaxed">{t("privacy.s5p1")}</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>{t("privacy.s5l1")}</li>
                <li>{t("privacy.s5l2")}</li>
                <li>{t("privacy.s5l3")}</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("privacy.s6Title")}</h2>
              <p className="mb-4 leading-relaxed">{t("privacy.s6p1")}</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>{t("privacy.s6l1")}</li>
                <li>{t("privacy.s6l2")}</li>
                <li>{t("privacy.s6l3")}</li>
                <li>{t("privacy.s6l4")}</li>
                <li>{t("privacy.s6l5")}</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("privacy.s7Title")}</h2>
              <p className="leading-relaxed">{t("privacy.s7p1")}</p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-foreground mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>{t("privacy.s8Title")}</h2>
              <p className="mb-4 leading-relaxed">{t("privacy.s8p1")}</p>
              <div className="bg-secondary rounded-xl p-6">
                <p className="font-semibold text-foreground mb-2">{t("privacy.s8company")}</p>
                <p>{t("privacy.s8email")} <a href="mailto:info@drosavide.lv" className="text-primary hover:underline">info@drosavide.lv</a></p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <footer className="bg-foreground text-white py-8">
        <div className="section-container text-center">
          <p className="text-white/60 text-sm">{t("footer.copyright", { year: new Date().getFullYear() })}</p>
        </div>
      </footer>
    </div>
  );
}
